// OWNER: AREA-OPS (applications/*). Components go in src/features/assets.
// Assets owned by this application, plus the shared library on request.
import { createFileRoute } from '@tanstack/react-router'
import { Switch } from '@/components/ui/switch'
import { AssetsTable } from '@/features/assets/AssetsTable'

interface AppAssetsSearch {
  q?: string
  shared?: boolean
}

export const Route = createFileRoute('/applications/$appId/assets')({
  staticData: { crumb: 'Assets' },
  validateSearch: (s: Record<string, unknown>): AppAssetsSearch => ({
    q: typeof s.q === 'string' && s.q ? s.q : undefined,
    shared: s.shared === true || s.shared === 'true' ? true : undefined,
  }),
  component: AppAssetsPage,
})

function AppAssetsPage() {
  const { appId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <AssetsTable
      filters={{ app: appId, includeShared: !!search.shared }}
      q={search.q ?? ''}
      onQChange={(q) =>
        void navigate({ search: (prev) => ({ ...prev, q: q || undefined }), replace: true })
      }
      showOwner={!!search.shared}
      defaultOwner={appId}
      persistKey="app-assets"
      toolbar={
        <label className="flex h-8 items-center gap-2 rounded-md px-2 text-sm text-ink-2">
          <Switch
            checked={!!search.shared}
            onCheckedChange={(v) =>
              void navigate({
                search: (prev) => ({ ...prev, shared: v || undefined }),
                replace: true,
              })
            }
            aria-label="Include shared assets"
          />
          Include shared assets
        </label>
      }
    />
  )
}
